import React from 'react';
import PropTypes from 'prop-types';
import { PdxBadge } from '@pagerduty/pd-react-components';

const badgeStyles = {
  fontSize: '0.65rem',
  paddingRight: '4px',
  paddingBottom: '4px'
};

const newBadgeStyles = {
  ...badgeStyles,
  backgroundColor: '#e83e8c'
};

const PdxNavBadge = ({ type }) => {
  const styles = type === 'beta' ? badgeStyles : newBadgeStyles;
  const text = type === 'beta' ? 'Beta' : 'New';

  return <PdxBadge color="primary" style={styles}>{text}</PdxBadge>;
};

PdxNavBadge.propTypes = {
  type: PropTypes.oneOf(['beta', 'new']).isRequired
};

export default PdxNavBadge;
